import { useEffect } from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';

import { DefaultTooltip, MenuItem, useSidebarContext } from 'twyne-new.ui';

import { useAppLayoutContext } from './context';

export default function AppSidebarItem({ to, icon, alias, hasPermission, require }) {
  const match = useRouteMatch(to)
  const isMatched = !!match
  const { setExpanded, collapsed } = useSidebarContext()
  const { setMenuCollapsed } = useAppLayoutContext()

  useEffect(() => {
    if (isMatched) {
      setMenuCollapsed(true)
    }
  }, [isMatched, setMenuCollapsed])

  if (hasPermission && require && !hasPermission(require)) {
    return null
  }

  return <NavLink to={to}>
    <DefaultTooltip content={collapsed && alias} wrapperProps={{ asChild: true }} side='right'>
      <MenuItem icon={icon} active={isMatched} onClick={() => setExpanded('')}>
        {alias}
      </MenuItem>
    </DefaultTooltip>
  </NavLink>
}
